import {useEffect} from "react";
import CryptoJS from "crypto-js";

/**
 * academy intro page
 * https://www.bizting.co.kr/hosting/academy/intro
 * */
const HostingAIntro = () => {
    useEffect(() => {
        window.sessionStorage.setItem('adSrc', 'eyAiYWRQYXRoIiA6ICAiQUNBREVNWSJ9');

        const state = {
            hostType: 'A',
        };

        let encryptedState = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(state), process.env.REACT_APP_AES_ENCRYPT_KEY).toString());

        let url = `${process.env.REACT_APP_DEFAULT_INTRO_REDIRECT_URI}`;
        url += `?state=${encryptedState}`;

        window.location.href = url;
    });
};

export default HostingAIntro;